import { memo, PropsWithChildren } from "react";
import { cn } from "utils";


interface ForecastCardProps {
  className?: string;
}

const baseCardClass = "gap-6 rounded-[12px] flex";

const ForecastCard = ({
  className = "",
  children,
}: PropsWithChildren<ForecastCardProps>) => {
  return <div className={cn(baseCardClass, className)}>{children}</div>;
};

export default memo(ForecastCard);
